const getDateOL = (date = new Date(), type = 'short', moreDays = 0) => {
    const result = new Date(date);
    // JS ajusta automáticamente mes y año si el resultado de sumarle días
    // se sale del rango del mes actual.
    result.setDate(result.getDate() + moreDays);

    const year = result.getFullYear();
    const month = String(result.getMonth() + 1).padStart(2, '0');
    const day = String(result.getDate()).padStart(2, '0');

    if (type === 'short') {
        return `${year}-${month}-${day}`;
    }

    const hours = String(result.getHours()).padStart(2, '0');
    const minutes = String(result.getMinutes()).padStart(2, '0');
    const seconds = String(result.getSeconds()).padStart(2, '0');
    
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

const validateUser = function () {
    let user = localStorage.getItem("infoAssist");
    return user;
}

function filterData(data, searchValue, searchProperties) {
    //return !searchValue ? data : data?.filter((dato) => dato[searchProperty].toLowerCase().includes(searchValue.toLowerCase()));
    return !searchValue ? data : data?.filter((dato) => {
        return searchProperties?.some(prop => {
            return dato[prop]?.toLowerCase().includes(searchValue.toLowerCase());
        });
    });
};

function sortDataListSimple(dataList, sortConfig) {
    dataList?.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
    });

    return dataList
};

const formatDate = function (date = new Date(), type = 'date-time', typeTime = 'short') {
    //let fecha = new Date(date);
    let year = date.getFullYear();
    let month = String(date.getMonth() + 1).padStart(2, '0');
    let day = String(date.getDate()).padStart(2, '0');
    let hour = String(date.getHours()).padStart(2, '0');
    let minute = String(date.getMinutes()).padStart(2, '0');
    let seconds = String(date.getSeconds()).padStart(2, '0');

    let formattedDate;
    if (type === 'date') {
        formattedDate = `${year}-${month}-${day}`;
    } else if (type === 'time') {
        if (typeTime === 'long') {
            formattedDate = `${hour}:${minute}:${seconds}`;
        } else {
            formattedDate = `${hour}:${minute}`;
        }
    } else {
        if (typeTime === 'long') {
            formattedDate = `${year}-${month}-${day} ${hour}:${minute}:${seconds}`;
        } else {
            formattedDate = `${year}-${month}-${day} ${hour}:${minute}`;
        }
    }

    return formattedDate;
};

const minutesDiff = (date1, date2, type = 'date') => {
    let diffEnMin;
    if (type === 'date') {
        let fecha1 = (/^\d{4}-\d{2}-\d{2}$/.test(date1) ? new Date(`${date1}T00:00:00`) : new Date(date1));
        let fecha2 = (/^\d{4}-\d{2}-\d{2}$/.test(date2) ? new Date(`${date2}T00:00:00`) : new Date(date2));

        let diffEnMs = fecha1.getTime() - fecha2.getTime();
        diffEnMin = Math.floor(Math.abs(diffEnMs / 60000));
    } else {
        let fecha1 = new Date();
        let fecha2 = new Date();
        let [horas1, minutos1] = date1.split(':').map(Number);
        let [horas2, minutos2] = date2.split(':').map(Number);

        if (horas2 < horas1) {
            fecha2.setDate(fecha1.getDate() + 1);
        }
        fecha1 = new Date(`${formatDate(fecha1, 'date')}T${date1}`);
        fecha2 = new Date(`${formatDate(fecha2, 'date')}T${date2}`);

        let diffEnMs = fecha2.getTime() - fecha1.getTime();
        diffEnMin = diffEnMs / 60000;
    }
    return diffEnMin;
};

const convertHour = (total) => {
    let hours = parseInt(total / 60);
    let minute = total - (hours * 60);
    let viewHours = '';
    if (hours > 0) {
        viewHours = viewHours + hours + 'H '
    }
    if (minute > 0) {
        viewHours = viewHours + minute + 'm'
    }
    return viewHours;
}

const clearBrowserCache = () => {
    const isiPhone = () => {
        return /iPhone|iPod/.test(navigator.userAgent);
    };
    if (!isiPhone()) {
        window.location.reload(true);
    }
};

const mapData = (data, properties) => {
    return data?.map(element => {
        const mappedElement = { value: element[properties[0]], label: element[properties[1]] };
        properties.forEach(property => {
            mappedElement[property] = element[property];
        });
        return mappedElement;
    });
};

const calcularDiferenciaDias = (inicio, retorno) => {
    const fechaInicio = new Date(inicio);
    const fechaRetorno = new Date(retorno);
    const diferenciaMs = fechaRetorno - fechaInicio;
    const dias = Math.ceil(diferenciaMs / (1000 * 60 * 60 * 24));
    return dias;
};

const generarNpapeleta = (nombreCompleto, n_papeleta, persona_id) => {
    const iniciales = nombreCompleto
        .split(' ')
        .filter(word => word.trim() !== '-') // evitar guiones
        .map(word => word.charAt(0))
        .join('');
    const numeroFormateado = n_papeleta === null
        ? '001'
        : String(Number(n_papeleta.slice(-3)) + 1).padStart(3, '0');
    return `${iniciales}${persona_id}${numeroFormateado}`
}

export { getDateOL, validateUser, filterData, formatDate, minutesDiff, convertHour, sortDataListSimple, clearBrowserCache, mapData, calcularDiferenciaDias, generarNpapeleta };